import {
  Button,
  Grid,
  GridItem,
  HStack,
  Tag,
  TagLabel,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PrimaryCard from "../common/cards/PrimaryCard";

const CustomerCard = ({
  beneficiaryName,
  vehicleBrand,
  vehicleModel,
  licensePlate,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <PrimaryCard title={t("beneficiaryServices.customer")} {...props}>
      <HStack
        flexWrap={"wrap-reverse"}
        gap={16}
        justifyContent={"space-between"}
      >
        <Grid
          flexGrow={3}
          gap={4}
          templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(3, 1fr)" }}
          templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(3, 1fr)" }}
        >
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>{beneficiaryName}</TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>
                <Trans>beneficiaryServices.operatorPole</Trans>
              </TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>
                <Trans>beneficiaryServices.divisionManagerName</Trans>
              </TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>{vehicleBrand}</TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>{vehicleModel}</TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>{licensePlate}</TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>
                <Trans>beneficiaryServices.contractType</Trans>
              </TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>
                <Trans>beneficiaryServices.supportType</Trans>
              </TagLabel>
            </Tag>
          </GridItem>
          <GridItem colSpan={1} rowSpan={1}>
            <Tag>
              <TagLabel>
                <Trans>beneficiaryServices.breakdownType</Trans>
              </TagLabel>
            </Tag>
          </GridItem>
        </Grid>
        <VStack alignItems={"stretch"} flexGrow={1} gap={4}>
          <Button isDisabled={true} variant={"primary"}>
            <Trans>beneficiaryServices.agreementRequest</Trans>
          </Button>
          <Button isDisabled={true} variant={"primary"}>
            <Trans>beneficiaryServices.contractForm</Trans>
          </Button>
          <Button isDisabled={true} variant={"primary"}>
            <Trans>beneficiaryServices.focusPoint</Trans>
          </Button>
        </VStack>
      </HStack>
    </PrimaryCard>
  );
};

export default React.memo(CustomerCard);
